export default __webpack_public_path__ + "static/activities_image_three_mobile-38da79ee96aba69baa9d6743dd77483a.jpg";